<p-dialog
  [visible]="isOpen()"
  (visibleChange)="onVisibleChange($event)"
  [header]="title()"
  [modal]="true"
  [closable]="true"
  [style]="{width: '420px', maxWidth: '90vw'}"
  [contentStyle]="{padding: '0'}"
  [blockScroll]="true"
  [focusOnShow]="false"
  styleClass="branduals-dialog license-picker-dialog">

  @if (loading()) {
    <div class="picker-loading">
      <p-progressSpinner strokeWidth="3" [style]="{ width: '32px', height: '32px' }" />
      <span>{{ 'common.loading' | translate }}…</span>
    </div>
  } @else {
    @if (assignable().length > 5) {
      <div class="search-section">
        <div class="search-input-wrapper">
          <fa-duotone-icon [icon]="faSearch" class="search-icon"></fa-duotone-icon>
          <input type="text" pInputText class="search-input"
            [placeholder]="'licenses.picker.search' | translate"
            [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
        </div>
      </div>
    }

    <div class="picker-list">
      @if (filtered().length === 0) {
        <div class="empty-state">
          @if (searchQuery()) {
            <p>{{ 'common.noResults' | translate }}</p>
          } @else {
            <p>{{ 'licenses.picker.empty' | translate }}</p>
          }
        </div>
      } @else {
        @for (def of filtered(); track def.id) {
          <button type="button" class="picker-item" appLabelDescribedBy (click)="pick(def)">
            <div class="picker-icon">
              <fa-duotone-icon [icon]="faFileCertificate"></fa-duotone-icon>
            </div>
            <div class="picker-info">
              <span class="picker-name">
                <app-operational-label [value]="def.names" [nested]="true" />
              </span>
              <span class="picker-sub">
                {{ 'compliance.enums.licenseType.' + def.licenseType | translate }}
                <span class="sub-separator">&middot;</span>
                @let d = daysUntil(def.expiresAt);
                @if (d === null) { {{ 'compliance.rights.noExpiry' | translate }} }
                @else if (d < 0) { {{ 'compliance.rights.expired' | translate }} }
                @else { {{ d | l10nPlural: 'compliance.rights.expiresIn' }} }
              </span>
            </div>
          </button>
        }
      }
    </div>
  }
</p-dialog>
